import { render, staticRenderFns } from "./firstClassify.vue?vue&type=template&id=b7777fb6&scoped=true&"
import script from "./firstClassify.vue?vue&type=script&lang=js&"
export * from "./firstClassify.vue?vue&type=script&lang=js&"
import style0 from "./firstClassify.vue?vue&type=style&index=0&id=b7777fb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7777fb6",
  null
  
)

export default component.exports